import { render, staticRenderFns } from "./ResearchSectionsSummary.vue?vue&type=template&id=07a1ec76"
import script from "./ResearchSectionsSummary.vue?vue&type=script&lang=js"
export * from "./ResearchSectionsSummary.vue?vue&type=script&lang=js"
import style0 from "./ResearchSectionsSummary.vue?vue&type=style&index=0&id=07a1ec76&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07a1ec76')) {
      api.createRecord('07a1ec76', component.options)
    } else {
      api.reload('07a1ec76', component.options)
    }
    module.hot.accept("./ResearchSectionsSummary.vue?vue&type=template&id=07a1ec76", function () {
      api.rerender('07a1ec76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/ResearchSectionsSummary.vue"
export default component.exports